import { API_CONFIG } from '../config';
import { adminAuthHeaders } from './adminAuth';

const BASE = API_CONFIG.BASE_URL;
const headers = { 'Content-Type': 'application/json' };
const authHeaders = () => ({ ...headers, ...adminAuthHeaders() });

const buildUrl = (experience) => {
    let url = `${BASE}/management/content`;
    if (experience) url += `?experience=${encodeURIComponent(experience)}`;
    return url;
};

/**
 * GET /management/content[?experience=arena]
 *
 * El backend tiene un blob por experiencia. Sin parámetro lee `content.json`
 * (frontend principal). Con `experience='arena'` lee `content-arena.json`.
 *
 * Respuesta: { updated_at?, es: { escenarios, scene_moments?, skill_config, ... }, en: { ... } }
 */
export async function fetchAdminContent({ experience } = {}) {
    const res = await fetch(buildUrl(experience), { headers });
    if (!res.ok) throw new Error(`fetchAdminContent: ${res.status}`);
    return res.json();
}

/**
 * POST /management/content[?experience=arena]
 * Cuerpo bilingüe: { es: { escenarios[], scene_moments?, skill_config }, en: { ... } }.
 * El blob donde se guarda lo decide ?experience=. Responde { ok, updated_at, experience }.
 */
export async function publishAdminContent(payload, { experience } = {}) {
    const res = await fetch(buildUrl(experience), {
        method: 'POST',
        headers: authHeaders(),
        body: JSON.stringify(payload),
    });
    if (!res.ok) {
        let msg = `publishAdminContent: ${res.status}`;
        try {
            const body = await res.json();
            if (body.error) msg = body.error;
        } catch (_) {}
        throw new Error(msg);
    }
    return res.json();
}

/**
 * DELETE /management/content[?experience=arena]
 * Idempotente: no falla si el blob no existía.
 */
export async function deleteAdminContent({ experience } = {}) {
    const res = await fetch(buildUrl(experience), {
        method: 'DELETE',
        headers: authHeaders(),
    });
    if (!res.ok) throw new Error(`deleteAdminContent: ${res.status}`);
    return res.json();
}

/**
 * POST /management/login — valida la clave actual contra ADMIN_PASSWORD del backend.
 * Solo se usa para verificar antes de guardar la clave en sessionStorage.
 * Pasa la clave directamente (no usa la guardada). El prefijo /admin lo reserva
 * el host de Azure Functions, por eso usamos /management/.
 */
export async function loginAdmin(password) {
    const res = await fetch(`${BASE}/management/login`, {
        method: 'POST',
        headers: { ...headers, 'x-admin-password': password || '' },
    });
    if (res.status === 401) throw new Error('Clave incorrecta');
    if (res.status === 503) throw new Error('Backend sin ADMIN_PASSWORD configurado');
    if (!res.ok) throw new Error(`loginAdmin: ${res.status}`);
    return res.json();
}
